import * as React from 'react'
import styled from 'styled-components'
import I18n from 'core/i18n'
import * as interfaces from 'static/interfaces'
import { AvatarImage, Panel, Score } from 'components/atoms'
import RoleLabel from 'components/atoms/RoleLabel'
import TextWrap from 'components/atoms/TextWrap'

interface IProps {
  guide: interfaces.IUser
  averageReview: number
  reviewCount: number
}

// GuideProfilePanel : ガイドのアバター・名前・平均評価・自己紹介を並べたプロフィール.
const GuideProfilePanel: React.FC<IProps> = ({ guide, averageReview, reviewCount }) => (
  <Panel>
    <Wrapper>
      <AvatarImage avatarURL={guide.avatar_middle_url} size={120} />
      <div className="Info">
        <div className="Name">{guide.fullname}</div>
        <RoleLabel user={guide} />
        <div className="Score">
          <Score score={averageReview} />
          {averageReview} ({I18n.t('review.review_count', { count: reviewCount })})
        </div>
        <TextWrap text={guide.bio} noMargin={true} />
      </div>
    </Wrapper>
  </Panel>
)

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  .Info {
    flex: 1;
    min-width: 240px;
  }
  .Name {
    margin-bottom: 8px;
    font-size: 24px;
    font-weight: 700;
  }
  .Score {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 8px 0 16px;
  }
`

export default GuideProfilePanel
